export const STATUS_ICONS = {
    sent: (
        <svg viewBox="0 0 16 16" fill="none" className="h-4 w-4 text-gray-500">
            <path d="M2 8L6.5 12.5L14 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    delivered: (
        <svg viewBox="0 0 16 16" fill="none" className="h-4 w-4 text-gray-500">
            <path
                d="M2.5 9L5.5 12L9.5 7"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6 9L9 12L14 6.5"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),

    read: (
        <svg viewBox="0 0 16 16" fill="none" className="h-4 w-4 text-blue-600 dark:text-blue-400">
            <path
                d="M2.5 9L5.5 12L9.5 7"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6 9L9 12L14 6.5"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    failed: (
        <svg viewBox="0 0 16 16" fill="none" className="h-4 w-4 text-red-600 dark:text-red-400">
            <path d="M4.5 4.5L11.5 11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M11.5 4.5L4.5 11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
    ),
};
